import { css } from "@emotion/react";
import GBtn from "./GBtn";

type Props = Omit<React.ComponentProps<typeof GBtn>, "handleClick">;

/**
 
&::before {
      content: "";
      position: absolute;
      top: 0;
      left: ${left};
      top: ${top};
      height: 200%;
      box-shadow: none;
      width: 14px;
      background: ${shineColor};
      transform: rotate(35deg) translateX(0);
    } 

    &:hover::before {
      transition: all 0.6s linear;
      transform: translateX(${transitionDistance});
    }
 
 */

export default function GBtnShine(props: Props) {
  const { shineColor, ...restProps } = props;

  const transitionDistance =
    props.style && props.style?.width !== "100%"
      ? `calc(${props.style?.width} * 2.63)`
      : "300px";

  /*
  const left =
    props.style && props.style?.width !== "100%"
      ? `calc(-${props.style.width}/10 * 10)`
      : "-40px";

  const top =
    props.style && props.style?.width !== "100%"
      ? `calc(-${props.style.width}/10 * 2)`
      : "-10px";
      */

  const shineStyles = css`
    overflow: hidden;

    &:hover {
      filter: brightness(1);
    }

    &::before {
      content: "";
      position: absolute;
      left: -30%;
      height: 200%;
      box-shadow: none;
      width: 14px;
      background: ${shineColor};
      transform: rotate(35deg) translateX(0);
    }

    &:hover::before {
      transition: all ${props.duration ? `${props.duration}s` : "0.8s"} linear;
      left: 110%;
      transform: translateX(${transitionDistance});
    }
  `;

  return <GBtn css={shineStyles} {...restProps}></GBtn>;
}

// We need to add the below in framer

/*
addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    fontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#21242C",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 16,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    },
    shineColor: {
        title: "Shine Color",
        type: ControlType.Color,
        defaultValue: "rgba(255,255,255,.35)",
    },
    duration: {
        title: "Duration",
        type: ControlType.Number,
        defaultValue: 0.8,
        description: "Animation duration",
    },
});
*/
